import React, { useContext, useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Icon } from '@ellucian/ds-icons/lib';
import {
    Typography,
    makeStyles,
    Tooltip,
    IconButton
} from '@ellucian/react-design-system/core';
import {
    spacing40,
    spacing60
} from '@ellucian/react-design-system/core/styles/tokens';
import { useSnackbar } from '../SnackbarContext/SnackbarContext';
import { routes } from '../Helpers/Configuration';
import MFAContext from './MFAContext';
import { downloadFile } from '../Helpers/fileHelpers';
import { useApi } from '../ApiContext';
import LoadingButton from '../Common/LoadingButton';

const useStyles = makeStyles((theme) => ({
    mainGrid: {
        alignItems: 'center',
    },
    title: {
        marginBottom: spacing60,
        textAlign: 'justify'
    },
    backupCode: {
        marginBottom: spacing60,
        display: 'flex',
        alignItems: 'center'
    },
    backupCodeItem: {
        marginRight: spacing40
    },
    container: {
        margin: '4rem auto 4rem auto',
        maxWidth: '800px',
    },
    root: {
        padding: `${spacing40} 0`,
        width: '100%',
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'row-reverse',
    },
    [theme.breakpoints.down('sm')]: {
        container: {
            margin: `${spacing40} auto ${spacing40} auto`,
            display: 'flex',
            justifyContent: 'center'
        },
        codeContainer: {
            width: '100%'
        },
        mainGrid: {
            width: '90%'  
        }
    },
}));

const RecoveryCodeReadOnly = () => {
    const classes = useStyles();
    const { formatMessage } = useIntl();
    const { qrCodeInfo } = useContext(MFAContext);
    const snackbar = useSnackbar();
    const api = useApi();
    const [isDisabled, setIsDisabled] = useState(false);

    const handleDownload = () => {
        let contentType = 'text/plain;charset=utf-8;';
        downloadFile(`${formatMessage({id : 'totpRecoveryCodeFile'})}.txt`, qrCodeInfo.backupCode, contentType);
        snackbar.success(formatMessage({ id: 'totpRecoveryCodedownloaded' }));
    };

    const handleContinue = async(e) => {
        try {     
            e.preventDefault();
            setIsDisabled(true);
            const applications = await api.applicationForms.getAll();
            if (applications.length === 1 ){ 
                window.location.href = routes.applicationFormStartWithId(applications[0].id);
            } else {
                window.location.href = routes.home;
            }     
        } catch (error) {
            setIsDisabled(false);
            console.error(error);
        }
    };

    return (
        <div className={classes.root}>
            <div className={classes.container}>
                <div  className={classes.mainGrid}>
                    <Typography className={classes.title}>
                        <strong><FormattedMessage id="totpRecoveryCodeText" /></strong>
                    </Typography>
                    <Typography variant="body1" className={classes.title}>
                        <FormattedMessage id='applicationRetrievalRecoveryCodeDownloadInstructions'/>
                    </Typography>
                    <div className={classes.backupCode}>
                        <Typography className={classes.backupCodeItem}>
                            <strong>{qrCodeInfo.backupCode}</strong>
                        </Typography>
                        <Tooltip title={formatMessage({ id: 'totpRecoveryCodeDownload' })}>
                            <IconButton
                                color="gray"
                                onClick={handleDownload}
                            >
                                <Icon name="download" />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <div className={classes.buttonContainer}>
                        <LoadingButton
                            color="primary"
                            className={classes.button}
                            onClick={handleContinue}
                            isLoading={isDisabled}
                        >
                            <FormattedMessage id="continue" />
                        </LoadingButton>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default RecoveryCodeReadOnly;
